/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
  'backbone',
  'underscore'
], function(
  Backbone,
  _
)
{

  function Environment (atts, options)
  {
    this.varRefs = {};
    this.options = options || {};
    this.frames = [];
    if (atts != null) {
      this.pushFrame(atts);
    }
  }

  _.extend(Environment.prototype, Backbone.Events, {

    
    refVariable: function(name) {
      if (typeof this.varRefs[name] != 'number') {
        this.varRefs[name] = 1;
      }
      else {
        this.varRefs[name] += 1;
      }
    },

    unrefVariable: function(name) {
      var ref = this.varRefs[name];
      if (typeof ref == 'number') {
        this.varRefs[name] = Math.max(ref - 1, 0);
      }
    },

    referencesVariable: function(name) {
      return this.varRefs[name] > 0;
    },    

    setVariable: function (name, value) {
      _.last(this.frames).set(name, value);
    },

    setVariables: function (attributes) {
      _.last(this.frames).set(attributes);
    },

    lookup: function(key) {
      var frameIdx = _.findLastIndex(this.frames, function(frame) {
        return frame.attributes[key];
      });
      if (frameIdx == -1) {
        return null;
      }
      return this.frames[frameIdx].attributes[key];
    },
    
    varNames: function () {
      return _.uniq(_.flatten(_.map(this.frames, function(frame) { return _.keys(frame.attributes); })));
    },

    getBindings: function() {
      // binding in last frame wins
      var extendArgs = _.reduce(this.frames,
                                function(args, frame) {
                                  args.push(frame.attributes);
                                  return args;
                                },
                                [{}]);
      return _.extend.apply(_, extendArgs);
    },
    
    handleModelEvent: function (event) {
      // just forward it to this.
      this.trigger.apply(this, arguments);
    },

    pushFrame: function(atts) {
      // question: should we only listen to the current frame?
      var frame = new Backbone.Model(atts);
      this.listenTo(frame, "all", this.handleModelEvent);
      this.frames.push(frame);
    },

    pushFrameInClonedEnv: function(atts) {
      var env = new Environment();
      env.options = this.options;
      env.frames = env.frames.concat(this.frames);
      var that = this;
      // TODO delegate the handle Events on the prevous environment.
      //  I think we should keep a parent environment instead
      // _.each(env.frames, function(frame) {
      //   that.listenTo(frame, "all", that.handleModelEvent);
      // });
      env.pushFrame(atts);
      return env;
    },
    
    popFrame: function() {
      if (this.frames.length == 0) {
        return;
      }
      var frame = this.frames.pop();
      if (frame) {
        this.stopListening(frame);
      }
    },
    
    createExprFunction: function (exprAsString) {
      // TODO optimize: currently we use all vars in the environment.
      var createFunArgs = this.varNames();
      createFunArgs.push('return ' + exprAsString);
      var exprFun = Function.apply(null, createFunArgs);
      exprFun.argNames = createFunArgs.slice(0, -1);
      return exprFun;
    },

    applyExprFunction: function(exprFun) {
      if (!exprFun.argNames) {
        throw Error("Invalid expression function");
      }
      // TODO optimize: currently we use all vars in the environment.
      var that = this;
      var exprArgs = _.map(exprFun.argNames, function (argName) {
        var val = that.lookup(argName);
        if (val && _.isFunction(val)) {
          val = val();
        }
        return val;
      });
      return exprFun.apply(null, exprArgs);
    },

    evaluate: function (exprAsString) {
      var exprFun = this.createExprFunction(exprAsString);
      return this.applyExprFunction(exprFun);
    },
    
    destroy: function () {
      this.stopListening();
    }
    
  });
  return Environment;
});
